export default __webpack_public_path__ + "images/loggedout/home/modularPage/experiance_game-0a90d2660bebc67ebf9125d95a0c6a66.png";